import script from "./ContactRequestModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactRequestModal.vue?vue&type=script&setup=true&lang=js"

import "./ContactRequestModal.vue?vue&type=style&index=0&id=b2ecd74e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2ecd74e"]])

export default __exports__